export default {
	"C": false,
	"Other": false,
	"Cc": false,
	"Control": false,
	"Cf": false,
	"Format": false,
	"Cn": false,
	"Unassigned": false,
	"Co": false,
	"Private_Use": false,
	"Cs": false,
	"Surrogate": false,
	"L": false,
	"Letter": false,
	"LC": false,
	"Cased_Letter": false,
	"Ll": false,
	"Lowercase_Letter": false,
	"Lm": false,
	"Modifier_Letter": false,
	"Lo": false,
	"Other_Letter": false,
	"Lt": false,
	"Titlecase_Letter": false,
	"Lu": false,
	"Uppercase_Letter": false,
	"M": false,
	"Mark": false,
	"Mc": false,
	"Spacing_Mark": false,
	"Me": false,
	"Enclosing_Mark": false,
	"Mn": false,
	"Nonspacing_Mark": false,
	"N": false,
	"Number": false,
	"Nd": false,
	"Decimal_Number": false,
	"Nl": false,
	"Letter_Number": false,
	"No": false,
	"Other_Number": false,
	"P": false,
	"Punctuation": false,
	"Pc": false,
	"Connector_Punctuation": false,
	"Pd": false,
	"Dash_Punctuation": false,
	"Pe": false,
	"Close_Punctuation": false,
	"Pf": false,
	"Final_Punctuation": false,
	"Pi": false,
	"Initial_Punctuation": false,
	"Po": false,
	"Other_Punctuation": false,
	"Ps": false,
	"Open_Punctuation": false,
	"S": false,
	"Symbol": false,
	"Sc": false,
	"Currency_Symbol": false,
	"Sk": false,
	"Modifier_Symbol": false,
	"Sm": false,
	"Math_Symbol": false,
	"So": false,
	"Other_Symbol": false,
	"Z": false,
	"Separator": false,
	"Zl": false,
	"Line_Separator": false,
	"Zp": false,
	"Paragraph_Separator": false,
	"Zs": false,
	"Space_Separator": false
};

export const NAME_ALIAS = {
	"C": "Other",
	"Other": "C",
	"Cc": "Control",
	"Control": "Cc",
	"Cf": "Format",
	"Format": "Cf",
	"Cn": "Unassigned",
	"Unassigned": "Cn",
	"Co": "Private_Use",
	"Private_Use": "Co",
	"Cs": "Surrogate",
	"Surrogate": "Cs",
	"L": "Letter",
	"Letter": "L",
	"LC": "Cased_Letter",
	"Cased_Letter": "LC",
	"Ll": "Lowercase_Letter",
	"Lowercase_Letter": "Ll",
	"Lm": "Modifier_Letter",
	"Modifier_Letter": "Lm",
	"Lo": "Other_Letter",
	"Other_Letter": "Lo",
	"Lt": "Titlecase_Letter",
	"Titlecase_Letter": "Lt",
	"Lu": "Uppercase_Letter",
	"Uppercase_Letter": "Lu",
	"M": "Mark",
	"Mark": "M",
	"Mc": "Spacing_Mark",
	"Spacing_Mark": "Mc",
	"Me": "Enclosing_Mark",
	"Enclosing_Mark": "Me",
	"Mn": "Nonspacing_Mark",
	"Nonspacing_Mark": "Mn",
	"N": "Number",
	"Number": "N",
	"Nd": "Decimal_Number",
	"Decimal_Number": "Nd",
	"Nl": "Letter_Number",
	"Letter_Number": "Nl",
	"No": "Other_Number",
	"Other_Number": "No",
	"P": "Punctuation",
	"Punctuation": "P",
	"Pc": "Connector_Punctuation",
	"Connector_Punctuation": "Pc",
	"Pd": "Dash_Punctuation",
	"Dash_Punctuation": "Pd",
	"Pe": "Close_Punctuation",
	"Close_Punctuation": "Pe",
	"Pf": "Final_Punctuation",
	"Final_Punctuation": "Pf",
	"Pi": "Initial_Punctuation",
	"Initial_Punctuation": "Pi",
	"Po": "Other_Punctuation",
	"Other_Punctuation": "Po",
	"Ps": "Open_Punctuation",
	"Open_Punctuation": "Ps",
	"S": "Symbol",
	"Symbol": "S",
	"Sc": "Currency_Symbol",
	"Currency_Symbol": "Sc",
	"Sk": "Modifier_Symbol",
	"Modifier_Symbol": "Sk",
	"Sm": "Math_Symbol",
	"Math_Symbol": "Sm",
	"So": "Other_Symbol",
	"Other_Symbol": "So",
	"Z": "Separator",
	"Separator": "Z",
	"Zl": "Line_Separator",
	"Line_Separator": "Zl",
	"Zp": "Paragraph_Separator",
	"Paragraph_Separator": "Zp",
	"Zs": "Space_Separator",
	"Space_Separator": "Zs"
};